import React, { createContext } from "react";

export const GlobalPageDataContext = createContext({});
